var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigTik(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 86,
    viewBox: "0 0 97 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97 43C97 66.748 77.748 86 54 86C43 86 43 86 43 86V0H54C77.748 0 97 19.252 97 43Z",
    fill: "#58DB9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8311 53C91.3235 71.9254 74.3052 86 54 86H43V53H95.8311Z",
    fill: "#2FBD7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 43C86 66.748 66.748 86 43 86C19.252 86 0 66.748 0 43C0 19.252 19.252 0 43 0C66.748 0 86 19.252 86 43Z",
    fill: "#84F0BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 43C75 60.673 60.673 75 43 75C25.327 75 11 60.673 11 43C11 25.327 25.327 11 43 11C60.673 11 75 25.327 75 43Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7998 10.2073C26.214 10.9247 25.9682 11.8421 25.2507 12.2563C19.854 15.3721 15.3726 19.8535 12.2568 25.2502C11.8426 25.9677 10.9252 26.2135 10.2078 25.7993C9.49034 25.385 9.24453 24.4677 9.65874 23.7502C13.0378 17.8975 17.898 13.0373 23.7507 9.65824C24.4682 9.24403 25.3855 9.48984 25.7998 10.2073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30953 27.6329C10.0766 27.9459 10.4447 28.8214 10.1317 29.5884L10.079 29.7184C9.76901 30.4866 8.89495 30.8582 8.12669 30.5482C7.35843 30.2383 6.98689 29.3642 7.29684 28.596C7.3158 28.549 7.33486 28.502 7.35401 28.4551C7.66698 27.688 8.5425 27.3199 9.30953 27.6329Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29.5H60C62.2245 29.5 64.23 30.84 65.0813 32.8952C65.9326 34.9504 65.4621 37.3161 63.8891 38.8891L47.8891 54.8891C46.8576 55.9205 45.4587 56.5 44 56.5H37L53 40.5V29.5Z",
    fill: "#58DB9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37 56.5H44C45.4587 56.5 46.8576 55.9205 47.8891 54.8891L56.7782 46H47.5L37 56.5Z",
    fill: "#2FBD7B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8891 31.1109C59.037 33.2588 59.037 36.7412 56.8891 38.8891L40.8891 54.8891C38.7412 57.037 35.2588 57.037 33.1109 54.8891L25.1109 46.8891C22.963 44.7412 22.963 41.2588 25.1109 39.1109C27.2588 36.963 30.7412 36.963 32.8891 39.1109L37 43.2218L49.1109 31.1109C51.2588 28.963 54.7412 28.963 56.8891 31.1109Z",
    fill: "#84F0BD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigTik);
export default __webpack_public_path__ + "static/media/big-tik.945b7ce4.svg";
export { ForwardRef as ReactComponent };